// Typelizer digest b7711c3d9e104c668ed08a40310b535c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** DELETE /c/:company_id/ledger/periods/:period_id/preparation */
  destroy: (
    params: { periodId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/ledger/periods/:period_id/preparation', params, options),
    method: 'delete',
  }),

  /** POST /c/:company_id/ledger/periods/:period_id/preparation */
  create: (
    params: { periodId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/periods/:period_id/preparation', params, options),
    method: 'post',
  }),
}
